import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'
import store from "@/store/";

var WS_BASE_URL = "/signalr/user";
"#if TARGET === 'development'"
WS_BASE_URL = "https://localhost:44307/signalr/user";
// WS_BASE_URL = "https://tone-generator.azurewebsites.net/signalr/user";
"#endif"

var VueSignalRPlugin = {};

VueSignalRPlugin.install = function(Vue) {

  Vue.$startUsersSignalR = async function() {
    try {
      this.$log.info('Creating the HubConnection user channel...'); 
      let hubConnection = new HubConnectionBuilder()    
          .withUrl(WS_BASE_URL)
          .configureLogging(LogLevel.Information)
          .withAutomaticReconnect()
          .build();
      
      await hubConnection.start();
      store.commit("mUserSignalRConnectionOpen", hubConnection);      
      this.$log.info('HubConnection user channel created');

      let _this = this;

      hubConnection.on('OnDeviceUsers', function (devices) {
        _this.$log.debug('OnDeviceUsers user channel got devices ', devices)
        store.commit("mUserSignalRDeviceUsers", devices)
      })
    } catch(e) {
      this.$log.error("Create HubConnection user channel failure: " + e.message);  
    }
  };

  Vue.$enterUserSignalr = async function() {
    try {
      let hubConnection = store.state.userSignalR.hubConnection
      let user = store.state.user.name
      let deviceId = store.state.currentDevice.deviceId
      await hubConnection.invoke("OnEnterDevice", deviceId, user)
    }
    catch(e) {
      this.$log.error("Message HubConnection user channel failure: " + e.message); 
    }
  }

  Vue.$exitUserSignalr = async function() {
    try {
      let hubConnection = store.state.userSignalR.hubConnection
      let user = store.state.user.name
      let deviceId = store.state.currentDevice.deviceId
      await hubConnection.invoke("OnExitDevice", deviceId, user)
    }
    catch(e) {
      this.$log.error("Message HubConnection user channel failure: " + e.message); 
    }
  }

  Vue.$stopUsersSignalr = async function() {
    try {
      let hubConnection = store.state.userSignalR.hubConnection
      await hubConnection.stop()
      store.commit("mUserSignalRConnectionClose");
      this.$log.info('HubConnection user channel stopped');
    } 
    catch(e) {
      this.$log.error("Disconnect HubConnection user channel failure: " + e.message); 
    }
  }

}

export default VueSignalRPlugin;